import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function Navbar() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  // 👉 Chamamos SEMPRE os hooks
  const [open, setOpen] = useState(false);

  // Se não estiver login → não mostra nada (mas só depois dos hooks serem declarados)
  if (!token) return null;

  const { role } = jwtDecode(token);

  function logout() {
    localStorage.removeItem("token");
    navigate("/login");
  }

  return (
    <>
      {/* TOP BAR */}
      <nav
        style={{
          padding: "10px 15px",
          background: "#222",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h3 style={{ margin: 0 }}>Auditoria OOH</h3>

        {/* BOTÃO HAMBURGUER */}
        <button
          onClick={() => setOpen(!open)}
          style={{
            fontSize: "24px",
            background: "none",
            border: "none",
            color: "white",
            cursor: "pointer",
          }}
        >
          ☰
        </button>
      </nav>

      {/* MENU DESLIZANTE */}
      <div
        style={{
          background: "#333",
          color: "white",
          padding: open ? "15px" : "0px",
          height: open ? "auto" : "0px",
          overflow: "hidden",
          transition: "all 0.3s ease",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <Link to="/" style={{ color: "white", textDecoration: "none" }} onClick={() => setOpen(false)}>
            📁 Projetos
          </Link>

          <Link to="/projetos/novo" style={{ color: "white", textDecoration: "none" }} onClick={() => setOpen(false)}>
            ➕ Novo Projeto
          </Link>

          <Link to="/inventario/lista" style={{ color: "white", textDecoration: "none" }} onClick={() => setOpen(false)}>
            📋 Ver Inventário
          </Link>

          <Link to="/inventario/novo" style={{ color: "white", textDecoration: "none" }} onClick={() => setOpen(false)}>
            🆕 Novo Inventário
          </Link>

          {role === "admin" && (
            <>
              <Link to="/users" style={{ color: "white", textDecoration: "none" }} onClick={() => setOpen(false)}>
                👤 Utilizadores
              </Link>

              <Link to="/operadores" style={{ color: "white", textDecoration: "none" }} onClick={() => setOpen(false)}>
                🏢 Operadores
              </Link>
              
              <Link to="/formatos" style={{ color: "white", textDecoration: "none" }} onClick={() => setOpen(false)}>
                🏢 Formatos
              </Link>

              <Link to="/tipologias" style={{ color: "white", textDecoration: "none" }} onClick={() => setOpen(false)}>
                🏢 Tipologias
              </Link>
              {/* TIPOS */}
              <Link to="/tipos" style={{ color: "white", textDecoration: "none" }} onClick={() => setOpen(false)}>
                📌 Tipos
              </Link>
              {/* TIPOS LOCALIZACAO */}
              <Link to="/tipos-localizacao" style={{ color: "white", textDecoration: "none" }} onClick={() => setOpen(false)}>
                📌 Tipos Localização
              </Link>

              <Link to="/localizacoes" style={{ color: "white", textDecoration: "none" }} onClick={() => setOpen(false)}>
                🗺️ Localizações
              </Link>

              <Link to="/inventario/mapa" style={{ color: "white", textDecoration: "none" }}
                onClick={() => setOpen(false)}
              >
                🗺️ Mapa Inventário
              </Link>

              <Link
                  to="/relatorios/campanhas"
                  style={{ color: "white", textDecoration: "none" }}
                  onClick={() => setOpen(false)}
                >
                  📊 Relatório Campanhas
                </Link>

              <Link
                  to="/relatorios/provas"
                  style={{ color: "white", textDecoration: "none" }}
                  onClick={() => setOpen(false)}
                >
                  📊 Relatório Provas
                </Link>
            </>
          )}

          <Link to="/change-password" style={{ color: "white", textDecoration: "none" }} onClick={() => setOpen(false)}>
            🔑 Alterar Password
          </Link>

          <button
            onClick={() => {
              setOpen(false);
              logout();
            }}
            style={{
              background: "red",
              color: "white",
              border: "none",
              padding: "8px 12px",
              borderRadius: "6px",
              marginTop: "10px",
              cursor: "pointer",
              width: "100px",
            }}
          >
            🚪 Logout
          </button>
        </div>
      </div>
    </>
  );
}
